import { render } from "./MyInformationView.vue?vue&type=template&id=0921d92e&scoped=true&ts=true"
import script from "./MyInformationView.vue?vue&type=script&lang=ts"
export * from "./MyInformationView.vue?vue&type=script&lang=ts"

import "./MyInformationView.vue?vue&type=style&index=0&id=0921d92e&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0921d92e"]])

export default __exports__